// NBN Order Item Constants
// Static data that doesn't need to be reactive

export const NBN_ASSURE_OPTIONS = [
  { text: "Business", value: "Business", disabled: false }
];

export const NBN_ORDER_TYPES = [
  { text: "Connect", value: "Connect", disabled: false },
  { text: "Transfer", value: "Transfer", disabled: false },
  { text: "Transition", value: "Transition", disabled: false }
];

export const INSTALLATION_WORKFORCES = [
  { text: "Pro install", value: "NBN Co Install", disabled: false },
  {
    text: "NCD already on-site",
    value: "RSP Install End User",
    disabled: false
  },
  {
    text: "Self-Installation Kit (SIK)",
    value: "NBN Co Install End User",
    disabled: false
  }
];

export const HARDWARE_OPTIONS = [
  {
    text: "TP-Link VX420-G2H",
    value: "TP-Link VX420-G2H",
    disabled: false
  },
  {
    text: "TP-Link VX230v",
    value: "TP-Link VX230v",
    disabled: false
  }
];

export const HISTORICAL_HARDWARE_OPTIONS = [
  { text: "Netcomm NL19MESH", value: "Netcomm NL19MESH", disabled: false },
  {
    text: "Netcomm NL20MESH",
    value: "Netcomm NL20MESH",
    disabled: false
  },
  {
    text: "2SG Standard VDSL Modem",
    value: "2SG Standard VDSL Modem",
    disabled: false
  }
];

export const APPOINTMENT_OPTIONS = [
  {
    label: "NO",
    value: "No"
  },
  {
    label: "YES - Earliest",
    value: "Earliest"
  },
  {
    label: "YES - Customize Appointment",
    value: "Customize"
  }
];

export const PRODUCT_TYPES = [
  { text: "FTTP", value: "FTTP", disabled: false },
  { text: "FTTP", value: "Fibre", disabled: false },
  { text: "FTTB", value: "FTTB", disabled: false },
  { text: "FTTN", value: "FTTN", disabled: false },
  { text: "FTTC", value: "FTTC", disabled: false },
  { text: "Fixed Wireless", value: "Fixed Wireless", disabled: false },
  { text: "HFC", value: "HFC", disabled: false }
];

export const END_USER_TYPES = [
  { text: "Business", value: "Business", disabled: false },
  { text: "Residential", value: "Residential", disabled: false }
];

export const INFORMED_CONSENT_OPTIONS = [
  { text: "Yes", value: "Yes", disabled: false },
  { text: "No", value: "No", disabled: false }
];

export const AFTER_HOURS_SITE_VISIT_OPTIONS = [
  { text: "Yes", value: "Yes", disabled: false },
  { text: "No", value: "No", disabled: false }
];

export const SERVICE_RESTORATION_SLA_OPTIONS = [
  {
    text: "Premium - 4 (24/7)",
    value: "Premium - 4 (24/7)",
    disabled: false
  },
  {
    text: "Premium - 6 (24/7)",
    value: "Premium - 6 (24/7)",
    disabled: false
  },
  {
    text: "Premium - 8 (24/7)",
    value: "Premium - 8 (24/7)",
    disabled: false
  },
  {
    text: "Premium - 12 (24/7)",
    value: "Premium - 12 (24/7)",
    disabled: false
  }
];

export const INDUCTION_REQUIRED_OPTIONS = [
  { text: "Yes", value: true, disabled: false },
  { text: "No", value: false, disabled: false }
];

export const SECURITY_CLEARANCE_OPTIONS = [
  { text: "Yes", value: true, disabled: false },
  { text: "No", value: false, disabled: false }
];

export const HERITAGE_SITE_OPTIONS = [
  { text: "Yes", value: true, disabled: false },
  { text: "No", value: false, disabled: false }
];

export const SERVICE_CLASS_REQUIRED_APPOINTMENT = [
  "0",
  "1",
  "2",
  "4",
  "5",
  "10",
  "11",
  "12",
  "20",
  "21",
  "22",
  "30",
  "31",
  "32"
];

// Product Template configurations
export const PRODUCT_TEMPLATES = {
  HFC: [
    {
      text: "Default HFC Template",
      value: "TPL350000001001/9.0/default",
      disabled: false
    },
    {
      text: "NHAS Tagged Data",
      value: "TPL370000001001/9.0/tag",
      disabled: false
    }
  ],
  FIBRE: [
    {
      text: "Default Fibre Template",
      value: "TPL070000001089/12.0/default",
      disabled: false
    },
    {
      text: "NFAS Tagged Data OBB MBB (TC2) OrderSLA Enhnced SLA",
      value: "TPL130000001031/12.0/tag",
      disabled: false
    }
  ],
  FIBRE_LEGACY: [
    {
      text: "Default Fibre Template",
      value: "TPL070000001089/10.0/default",
      disabled: false
    },
    {
      text: "NFAS Tagged Data OBB MBB (TC2) OrderSLA Enhnced SLA",
      value: "TPL130000001031/11.0/tag",
      disabled: false
    }
  ],
  FIBRE_NEW: [
    {
      text: "Default Fibre Template",
      value: "TPL070000001089/13.0/default",
      disabled: false
    },
    {
      text: "NFAS Tagged Data OBB MBB (TC2) OrderSLA Enhnced SLA",
      value: "TPL130000001031/13.0/tag",
      disabled: false
    }
  ],
  FIXED_WIRELESS: [
    {
      text: "Default Wireless Template",
      value: "TPL090000001010/4.0/default",
      disabled: false
    },
    {
      text: "NWAS Tagged Data OrderSLA",
      value: "TPL110000001010/4.0/tag",
      disabled: false
    }
  ],
  FIXED_WIRELESS_LEGACY: [
    {
      text: "Default Wireless Template",
      value: "TPL090000001010/4.0/default",
      disabled: false
    },
    {
      text: "NWAS Tagged Data OrderSLA",
      value: "TPL110000001010/3.0/tag",
      disabled: false
    }
  ],
  FTTC: [
    {
      text: "Default FTTC Template",
      value: "TPL310000001010/10.0/default",
      disabled: false
    },
    {
      text: "NCAS Tagged FTTC",
      value: "TPL330000001010/10.0/tag",
      disabled: false
    }
  ],
  FTTC_LEGACY: [
    {
      text: "Default FTTC Template",
      value: "TPL310000001010/7.0/default",
      disabled: false
    },
    {
      text: "NCAS Tagged FTTC",
      value: "TPL330000001010/7.0/tag",
      disabled: false
    }
  ],
  FTTB_FTTN: [
    {
      text: "Default FTTB/FTTN Template",
      value: "TPL310000001007/10.0/default",
      disabled: false
    },
    {
      text: "NCAS Tagged TC1 TC2 TC4 Enhanced SLA Band 2",
      value: "TPL330000001005/10.0/tag",
      disabled: false
    }
  ],
  FTTB_FTTN_LEGACY: [
    {
      text: "Default FTTB/FTTN Template",
      value: "TPL310000001007/10.0/default",
      disabled: false
    },
    {
      text: "NCAS Tagged TC1 TC2 TC4 Enhanced SLA Band 2",
      value: "TPL330000001005/9.0/tag",
      disabled: false
    }
  ]
};

export function hasPersistedSelectValue(value) {
  if (value == null) return false;
  const text = String(value).trim();
  return text !== "" && text.toLowerCase() !== "null";
}

export function normalizeNullableSelectValue(value) {
  return hasPersistedSelectValue(value) ? value : null;
}

export function firstPayloadValue(...values) {
  for (const value of values) {
    if (value !== undefined) return value;
  }
  return undefined;
}

export function includeCurrentSelectValue(options, value) {
  const result = Array.isArray(options) ? [...options] : [];
  if (hasPersistedSelectValue(value) && !result.includes(value)) {
    result.push(value);
  }
  return result;
}

export function resolveStoredNtdId(stored, existing) {
  if (hasPersistedSelectValue(stored)) return stored;
  return hasPersistedSelectValue(existing) ? existing : null;
}

export function resolveStoredNtdModifications(stored, existing) {
  if (hasPersistedSelectValue(stored)) return stored;
  return hasPersistedSelectValue(existing) ? existing : null;
}

// Persist column stores the offering ID (TPL…). The form select uses id/version/default|tag.
export function resolveStoredProductTemplate(stored, existing) {
  if (hasPersistedSelectValue(stored)) {
    const storedValue = String(stored).trim();
    if (storedValue.includes("/")) return storedValue;
    if (existing && String(existing).startsWith(storedValue + "/")) {
      return existing;
    }
    const all = Object.values(PRODUCT_TEMPLATES).flat();
    const match = all.find((t) => t.value.startsWith(storedValue + "/"));
    return match ? match.value : storedValue;
  }
  return existing || "";
}

export function resolveStoredNtdType(stored, existing) {
  if (hasPersistedSelectValue(stored)) return stored;
  return existing || "";
}

export function getCreateFormDefaultProductTemplate(productType, featureFlags) {
  const templates = getProductTemplates(productType, featureFlags || {}, false);
  return templates[0] ? templates[0].value : null;
}

export function getProductTemplateDisplayText(
  stored,
  productType,
  featureFlags,
  isOriginal
) {
  const resolved = resolveStoredProductTemplate(stored, stored);
  if (!hasPersistedSelectValue(resolved)) return null;
  const templates = getProductTemplates(
    productType,
    featureFlags || {},
    isOriginal
  );
  const all = Object.values(PRODUCT_TEMPLATES).flat();
  const match =
    templates.find(template => template.value === resolved) ||
    all.find(template => template.value === resolved) ||
    templates.find(template =>
      template.value.startsWith(String(resolved) + "/")
    ) ||
    all.find(template => template.value.startsWith(String(resolved) + "/"));
  return match ? match.text : resolved;
}

export function getCreateFormNtdIdOptions({
  orderType,
  currentNtdId,
  isOriginal,
  isFibreConnect,
  featureFlags = {},
  supportingResources = [],
  serviceClass = ""
} = {}) {
  const result = [];
  const resources = supportingResources || [];
  const hasFreeNtd = resources.some(resource =>
    (resource.uniPortD || []).some(port => port.status === "Free")
  );

  if (
    orderType === "Connect" &&
    (serviceClass === "1" || serviceClass === "2" || serviceClass === "5")
  ) {
    return ["NTD Installation Required"];
  }

  if (featureFlags.sog8191) {
    resources.forEach(resource => {
      const ports = Array.isArray(resource.uniPortD) ? resource.uniPortD : [];
      if (orderType === "Connect") {
        const hasFreePort = ports.some(port => port.status === "Free");
        const allPortsUsed =
          ports.length > 0 && ports.every(port => port.status === "Used");
        const isV3SinglePort =
          resource.NTDVersion === "V3" && resource.NTDType === "1_PORT";
        if (isV3SinglePort) {
          if (hasFreePort && !result.includes(resource.id)) {
            result.push(resource.id);
          } else if (
            allPortsUsed &&
            !result.includes("NTD Installation Required")
          ) {
            result.push("NTD Installation Required");
          }
        } else if (hasFreePort && !result.includes(resource.id)) {
          result.push(resource.id);
        }
      } else if (
        ports.some(port => port.status === "Used") &&
        !result.includes(resource.id)
      ) {
        result.push(resource.id);
      }
    });

    if (isOriginal && hasPersistedSelectValue(currentNtdId)) {
      result.push(currentNtdId);
    }

    const hasMultiPortNtd = resources.some(
      resource =>
        !(resource.NTDVersion === "V3" && resource.NTDType === "1_PORT")
    );
    if (
      hasMultiPortNtd &&
      !hasFreeNtd &&
      (serviceClass === "3" || serviceClass === "6") &&
      featureFlags.sog5947 &&
      orderType !== "Transfer"
    ) {
      if (!result.includes("Additional NTD Required")) {
        result.push("Additional NTD Required");
      }
    }
  } else {
    const status = orderType === "Connect" ? "Free" : "Used";
    resources.forEach(resource => {
      if (
        (resource.uniPortD || []).some(port => port.status === status) &&
        !result.includes(resource.id)
      ) {
        result.push(resource.id);
      }
    });
    if (isOriginal && hasPersistedSelectValue(currentNtdId)) {
      result.push(currentNtdId);
    }
    if (
      !hasFreeNtd &&
      (serviceClass === "3" || serviceClass === "6") &&
      featureFlags.sog5947 &&
      orderType !== "Transfer"
    ) {
      result.push("Additional NTD Required");
    }
  }

  if (orderType === "Connect" && result.length === 0) {
    result.push("Additional Line Installation");
  }
  if (isFibreConnect && result.length === 0) {
    result.push("NTD Installation Required");
  }
  return [...new Set(result.filter(Boolean))];
}

export function getCreateFormDefaultNtdType({
  ntdId,
  ntdModifications,
  currentNtd,
  productType,
  isFibreConnect,
  featureFlags = {},
  orderType
} = {}) {
  const VALID_PORTS = ["1_PORT", "4_PORT"];

  if (ntdModifications === NTD_MODIFICATION_OPTIONS.USE_SELECTED) {
    return currentNtd?.NTDType || null;
  }

  if (
    ntdModifications === NTD_MODIFICATION_OPTIONS.REPLACE_SELECTED ||
    ntdModifications === NTD_MODIFICATION_OPTIONS.REQUEST_NEW
  ) {
    if (
      featureFlags.sog8191 &&
      orderType === "Connect" &&
      currentNtd?.NTDType === "1_PORT" &&
      currentNtd?.uniPortD?.length === 1
    ) {
      return "4_PORT";
    }
    if (productType === "HFC") return "NTD_2.5";
    return isFibreConnect ? "1_PORT" : "4_PORT";
  }

  if (currentNtd?.NTDType) return currentNtd.NTDType;
  if (productType === "HFC") return "NTD_2.5";
  if (VALID_PORTS.includes(ntdId)) return ntdId;
  return isFibreConnect ? "1_PORT" : productType === "Fibre" || productType === "FTTP"
    ? "4_PORT"
    : null;
}

export function resolveCreateFormSelectDefaults({
  persistedNtdId,
  persistedNtdModifications,
  persistedNtdType,
  persistedProductTemplate,
  productType,
  orderType,
  isFibreConnect,
  isOriginal,
  featureFlags = {},
  supportingResources = [],
  serviceClass = "",
  primaryAccessTechnology
} = {}) {
  const isNCAS =
    productType === "FTTB" ||
    productType === "FTTC" ||
    productType === "FTTN";
  const isFibre =
    !!isFibreConnect ||
    primaryAccessTechnology === "Fibre" ||
    productType === "Fibre" ||
    productType === "FTTP";
  const applyNtdDefaults = !isNCAS || !!isFibreConnect;

  const productTemplate = hasPersistedSelectValue(persistedProductTemplate)
    ? resolveStoredProductTemplate(
        persistedProductTemplate,
        persistedProductTemplate
      )
    : getCreateFormDefaultProductTemplate(productType, featureFlags);

  if (!applyNtdDefaults) {
    return {
      ntdId: normalizeNullableSelectValue(persistedNtdId),
      ntdModifications: normalizeNullableSelectValue(persistedNtdModifications),
      ntdType: normalizeNullableSelectValue(persistedNtdType),
      productTemplate
    };
  }

  const ntdIdOptions = getCreateFormNtdIdOptions({
    orderType,
    currentNtdId: persistedNtdId,
    isOriginal,
    isFibreConnect,
    featureFlags,
    supportingResources,
    serviceClass
  });
  const ntdId = hasPersistedSelectValue(persistedNtdId)
    ? persistedNtdId
    : ntdIdOptions[0] || null;

  const currentNtd =
    (supportingResources || []).find(resource => resource.id === ntdId) ||
    (supportingResources || [])[0] ||
    null;
  const hasUsedPort = (currentNtd?.uniPortD || []).some(
    port => port.status === "Used"
  );
  const modificationOptions = getNtdModificationOptions(
    ntdId,
    currentNtd,
    hasUsedPort,
    { exceeded: [], original: ["available"] },
    featureFlags,
    orderType,
    isFibre
  );
  const ntdModifications = hasPersistedSelectValue(persistedNtdModifications)
    ? persistedNtdModifications
    : modificationOptions[0] ||
      (hasPersistedSelectValue(ntdId) &&
      ntdId !== "Additional Line Installation" &&
      ntdId !== "Additional NTD Required" &&
      ntdId !== "NTD Installation Required"
        ? NTD_MODIFICATION_OPTIONS.USE_SELECTED
        : NTD_MODIFICATION_OPTIONS.REQUEST_NEW);

  const ntdType = hasPersistedSelectValue(persistedNtdType)
    ? persistedNtdType
    : getCreateFormDefaultNtdType({
        ntdId,
        ntdModifications,
        currentNtd,
        productType,
        isFibreConnect,
        featureFlags,
        orderType
      });

  return {
    ntdId,
    ntdModifications,
    ntdType,
    productTemplate
  };
}

// Helper function to get product templates based on product type and feature flags
export function getProductTemplates(productType, featureFlags, isOriginal) {
  if(isOriginal)
  {
    const allTemplates = Object.values(PRODUCT_TEMPLATES).flat();
    return allTemplates;
  } else {
    switch (productType) {
      case "HFC":
        return featureFlags.sog7740
          ? PRODUCT_TEMPLATES.HFC
          : PRODUCT_TEMPLATES.HFC;
      case "Fibre":
      case "FTTP":
        // New Fibre orders are always v13.0; older versions only list for existing orders
        return PRODUCT_TEMPLATES.FIBRE_NEW;
      case "Fixed Wireless":
        return featureFlags.sog6028
          ? PRODUCT_TEMPLATES.FIXED_WIRELESS
          : PRODUCT_TEMPLATES.FIXED_WIRELESS_LEGACY;
      case "FTTC":
        return featureFlags.sog6028
          ? PRODUCT_TEMPLATES.FTTC
          : PRODUCT_TEMPLATES.FTTC_LEGACY;
      case "FTTB":
      case "FTTN":
        return featureFlags.sog6028
          ? PRODUCT_TEMPLATES.FTTB_FTTN
          : PRODUCT_TEMPLATES.FTTB_FTTN_LEGACY;
      default:
        return [];
    }
  }
}

// NTD Type options
export const NTD_TYPE_OPTIONS = ["1_PORT", "4_PORT"];

// NTD Type options for HFC
export const NTD_TYPE_OPTIONS_HFC = ["INTERNAL", "NTD_2.5"];

// NBN Fixed Wireless accepts title-case Internal only (SQ often returns INTERNAL)
export const NTD_TYPE_FIXED_WIRELESS = "Internal";

// V1/V2 WNTDs support up to FW Plus. These tiers require NTD replacement.
export const FW_HIGH_SPEED_TIERS = ["FW Home Fast", "FW Superfast"];

export const FW_SPECIAL_NTD_IDS = [
  "Additional Line Installation",
  "Additional NTD Required",
  "NTD Installation Required"
];

// NTD Modification options
export const NTD_MODIFICATION_OPTIONS = {
  USE_SELECTED: "USE SELECTED NTD",
  REPLACE_SELECTED: "REPLACE SELECTED NTD",
  REQUEST_NEW: "REQUEST NEW NTD"
};

// UI-only placeholders — never send these as NBN product.id or ANNR5291 reason
export const SPECIAL_NTD_IDS = [
  "NTD Installation Required",
  "Additional NTD Required",
  "Additional Line Installation"
];

export function isSpecialNtdId(ntdId) {
  return ntdId == null || ntdId === "" || SPECIAL_NTD_IDS.includes(ntdId);
}

export function isRealNtdId(ntdId) {
  if (isSpecialNtdId(ntdId)) return false;
  return /^NTD\d+/i.test(String(ntdId).trim());
}

export function resolveOnSiteNtdId(
  ntdId,
  existingNtdId,
  supportingResources = []
) {
  if (isRealNtdId(ntdId)) return ntdId;
  if (isRealNtdId(existingNtdId)) return existingNtdId;
  const ntd = (supportingResources || []).find(
    resource => resource?.id && isRealNtdId(resource.id)
  );
  return ntd?.id || null;
}

export function getNtdReplaceReason(onSiteNtdId) {
  if (!isRealNtdId(onSiteNtdId)) return null;
  return {
    code: "ANNR5291",
    reason: `${onSiteNtdId} to be replaced`
  };
}

export function isFibreProductType(productType) {
  return productType === "Fibre" || productType === "FTTP";
}

// A template kept from another product type (e.g. a loaded copper order) is
// dropped; types without a template list keep whatever was chosen.
export function resolveProductTemplateForType(
  productType,
  productTemplate,
  featureFlags
) {
  if (!hasPersistedSelectValue(productTemplate)) return productTemplate;
  const templates = getProductTemplates(productType, featureFlags || {}, false);
  if (templates.length === 0) return productTemplate;
  const id = String(productTemplate).split("/")[0];
  return templates.some(t => t.value.split("/")[0] === id)
    ? productTemplate
    : "";
}

// Product offering sent on a new order: the selected id/version/tag template,
// else the technology default.
export function resolveProductOffering(
  productType,
  productTemplate,
  featureFlags
) {
  let productId = "";
  let productVersion = "";
  const selected = resolveProductTemplateForType(
    productType,
    productTemplate,
    featureFlags
  );
  if (selected !== undefined && selected !== null && selected !== "") {
    const template = selected.split("/");
    productId = template[0];
    productVersion = template[1];
  }
  if (productType === "Fixed Wireless") {
    productId = productId === "" ? "TPL090000001010" : productId;
    productVersion = productVersion === "" ? "4.0" : productVersion;
  } else if (productType === "HFC") {
    productId = productId === "" ? "TPL350000001001" : productId;
    productVersion =
      productVersion === ""
        ? featureFlags.sog7740
          ? "9.0"
          : "8.0"
        : productVersion;
  } else if (productType === "Enterprise Ethernet") {
    productId = productId === "" ? "TPL900000000001" : productId;
    productVersion = productVersion === "" ? "1.1.0" : productVersion;
  } else if (productType === "FTTB" || productType === "FTTN") {
    productId = productId === "" ? "TPL310000001007" : productId;
    productVersion = productVersion === "" ? "10.0" : productVersion;
  } else if (productType === "FTTC") {
    productId = productId === "" ? "TPL310000001010" : productId;
    productVersion =
      productVersion === ""
        ? featureFlags.sog6028
          ? "10.0"
          : "7.0"
        : productVersion;
  } else if (isFibreProductType(productType)) {
    productId = productId === "" ? "TPL070000001089" : productId;
    productVersion = productVersion === "" ? "13.0" : productVersion;
  }

  return {
    id: productId,
    version: productVersion,
    specificationType: "Product Template"
  };
}

export function inferNtdModifications(request) {
  const resources = request?.realizedResource || [];
  const ntd = resources.find(resource =>
    resource?.product?.productSpecification?.id?.includes("NTD")
  );
  if (!ntd) return "";

  const action = String(ntd.action || "")
    .toUpperCase()
    .replace(/_/g, " ")
    .trim();

  if (action === "NO CHANGE") {
    return NTD_MODIFICATION_OPTIONS.USE_SELECTED;
  }
  if (action === "ADD") {
    const reasonCode = request.reasonCode?.code || request.reasonCode?.Code;
    return reasonCode === "ANNR5291"
      ? NTD_MODIFICATION_OPTIONS.REPLACE_SELECTED
      : NTD_MODIFICATION_OPTIONS.REQUEST_NEW;
  }
  return "";
}

export function resolveFibreNtdSelection(
  resources = [],
  { isConnect, isTransfer, sog8191 } = {}
) {
  const targetStatus = isTransfer ? "Used" : "Free";
  let matched = null;
  let v3Used = null;
  let firstReal = null;

  (resources || []).forEach(resource => {
    if (!firstReal && isRealNtdId(resource?.id)) {
      firstReal = resource;
    }

    const ports = resource?.uniPortD || [];
    const isV3SinglePort =
      resource?.NTDVersion === "V3" && resource?.NTDType === "1_PORT";
    const hasTarget = ports.some(port => port.status === targetStatus);
    const allUsed =
      ports.length > 0 && ports.every(port => port.status === "Used");

    if (!matched && hasTarget && isRealNtdId(resource.id)) {
      matched = resource;
    }
    if (!v3Used && isV3SinglePort && allUsed && isRealNtdId(resource.id)) {
      v3Used = resource;
    }
  });

  if (matched) {
    return { ntdId: matched.id, existingNtdId: matched.id };
  }

  if (sog8191 && isConnect) {
    if (v3Used) {
      return {
        ntdId: "NTD Installation Required",
        existingNtdId: v3Used.id
      };
    }
    return {
      ntdId: "Additional NTD Required",
      existingNtdId: firstReal?.id || ""
    };
  }

  return {
    ntdId: null,
    existingNtdId: firstReal?.id || ""
  };
}

export function normalizeFixedWirelessNtdType(ntdType) {
  if (ntdType == null || String(ntdType).trim() === "") {
    return NTD_TYPE_FIXED_WIRELESS;
  }
  if (String(ntdType).toLowerCase() === "internal") {
    return NTD_TYPE_FIXED_WIRELESS;
  }
  return ntdType;
}

export function inferFixedWirelessNtdVersion(currentNtd) {
  const version = (currentNtd?.NTDVersion ?? "").toUpperCase().trim();
  if (version) return version;

  // SQ reports Type INTERNAL for V2 WNTDs that omit NTDVersion
  const type = (currentNtd?.NTDType ?? "").toLowerCase().trim();
  if (type === "internal") return "V2";

  return "";
}

export function isFixedWirelessHighSpeedTier(bandwidthProfile) {
  return FW_HIGH_SPEED_TIERS.includes(bandwidthProfile);
}

export function doesFwSpeedExceedNtd(bandwidthProfile, speedTiersSupported) {
  if (!bandwidthProfile) return false;

  const supported = Array.isArray(speedTiersSupported)
    ? speedTiersSupported.filter(tier => tier?.supported)
    : [];

  if (supported.length > 0) {
    const supportedValues = supported.map(tier => tier.featureType);
    if (supportedValues.includes(bandwidthProfile)) return false;

    const allTiers = [
      "D12_U1_Mbps_TC4_P",
      "D25_U5_Mbps_TC4_P",
      "FWPlus_TC4_P",
      "FW Home Fast",
      "FW Superfast"
    ];
    const selectedIndex = allTiers.indexOf(bandwidthProfile);
    if (selectedIndex === -1) return isFixedWirelessHighSpeedTier(bandwidthProfile);

    const supportedIndices = supportedValues
      .map(tier => allTiers.indexOf(tier))
      .filter(index => index !== -1);

    if (supportedIndices.length === 0) {
      return isFixedWirelessHighSpeedTier(bandwidthProfile);
    }

    return selectedIndex > Math.max(...supportedIndices);
  }

  return isFixedWirelessHighSpeedTier(bandwidthProfile);
}

export function getForcedFixedWirelessNtdModification({
  ntdId,
  currentNtd,
  orderType,
  bandwidthProfile,
  speedTiersSupported
}) {
  if (orderType === "Transfer") {
    return NTD_MODIFICATION_OPTIONS.USE_SELECTED;
  }

  if (!ntdId || FW_SPECIAL_NTD_IDS.includes(ntdId)) {
    return NTD_MODIFICATION_OPTIONS.REQUEST_NEW;
  }

  const version = inferFixedWirelessNtdVersion(currentNtd);
  const isV1OrV2 = version === "V1" || version === "V2";

  if (isV1OrV2 && doesFwSpeedExceedNtd(bandwidthProfile, speedTiersSupported)) {
    return NTD_MODIFICATION_OPTIONS.REPLACE_SELECTED;
  }

  return NTD_MODIFICATION_OPTIONS.USE_SELECTED;
}

/** Normalize SQ NTDType values: "1-port", "1 Port", "1_PORT" → "1_PORT". */
export function normalizeNtdType(ntdType) {
  if (ntdType == null || ntdType === "") return "";
  return String(ntdType)
    .trim()
    .toUpperCase()
    .replace(/[-\s]+/g, "_");
}

export function normalizeNtdVersion(ntdVersion) {
  if (ntdVersion == null || ntdVersion === "") return "";
  return String(ntdVersion).trim().toUpperCase();
}

/** Connect rules: V3 hardware with a single UNI-D port. */
export function isV3SinglePortNtd(resource) {
  const version = normalizeNtdVersion(resource?.NTDVersion);
  const type = normalizeNtdType(resource?.NTDType);
  const portCount = Array.isArray(resource?.uniPortD)
    ? resource.uniPortD.length
    : 0;

  return (
    version === "V3" &&
    (type === "1_PORT" || type === "1PORT" || portCount === 1)
  );
}

/** Connect rules: V1 / V4 (and other multi-port) NTDs. */
export function isMultiPortNtd(resource) {
  return !!resource && !isV3SinglePortNtd(resource);
}

export function ntdHasFreePort(resource) {
  return (resource?.uniPortD || []).some(port => port.status === "Free");
}

export function ntdAllPortsUsed(resource) {
  const ports = resource?.uniPortD || [];
  return ports.length > 0 && ports.every(port => port.status === "Used");
}

/**
 * Connect NTD ID options from SQ supporting resources (screenshot / sog8191 rules):
 * - V1/V4 free port → real NTD id only (no Installation/Additional Required)
 * - V1/V4 all ports used → Additional NTD Required
 * - V3 1-port used → NTD Installation Required (replace with 4_PORT)
 * - V3 1-port free → real NTD id
 */
export function getConnectNtdIdOptionsFromResources(resources = []) {
  const result = [];
  let hasV3InstallationRequired = false;
  let hasMultiPortFullyUsed = false;
  let hasAnyFreePort = false;

  for (const resource of resources) {
    if (!resource) continue;

    const hasFree = ntdHasFreePort(resource);
    const allUsed = ntdAllPortsUsed(resource);

    if (hasFree) hasAnyFreePort = true;

    if (isV3SinglePortNtd(resource)) {
      if (hasFree && isRealNtdId(resource.id) && !result.includes(resource.id)) {
        result.push(resource.id);
      } else if (allUsed) {
        hasV3InstallationRequired = true;
      }
    } else {
      // V1 / V4 / multi-port
      if (hasFree && isRealNtdId(resource.id) && !result.includes(resource.id)) {
        result.push(resource.id);
      } else if (allUsed) {
        hasMultiPortFullyUsed = true;
      }
    }
  }

  // Prefer real ids when any free port exists — never offer specials in that case
  if (hasAnyFreePort) {
    return result;
  }

  if (hasV3InstallationRequired) {
    result.push("NTD Installation Required");
  } else if (hasMultiPortFullyUsed) {
    result.push("Additional NTD Required");
  }

  return result;
}

/**
 * Default Connect NTD ID selection for setNtdId (same rules as options).
 */
export function resolveConnectNtdIdSelection(resources = [], { isFibre = false } = {}) {
  const options = getConnectNtdIdOptionsFromResources(resources);
  if (options.length > 0) {
    return {
      ntdId: options[0],
      existingNtdId:
        resources.find(r => isRealNtdId(r?.id))?.id ||
        (isRealNtdId(options[0]) ? options[0] : null)
    };
  }

  if (isFibre) {
    return { ntdId: "Additional Line Installation", existingNtdId: null };
  }

  return { ntdId: null, existingNtdId: null };
}

/** Real on-site NTD id for payload / reasonCode (never a UI placeholder). */
export function resolveExistingNtdId(orderItem, sqNbnResult) {
  if (isRealNtdId(orderItem?.existingNtdId)) {
    return orderItem.existingNtdId;
  }
  if (isRealNtdId(orderItem?.ntdId)) {
    return orderItem.ntdId;
  }
  const resources =
    sqNbnResult?.sq?.siteRestriction?.supportingResource || [];
  const withId = resources.find(r => isRealNtdId(r?.id));
  return withId?.id || null;
}

/**
 * Applies NTD action/id/ntdType onto realizedResource[0] for Connect payloads.
 * Prevents RJ001000 when NBN requires an existing NTD ID (USE / REPLACE / Transfer).
 */
export function applyNtdRealizedResource(resource, orderItem, sqNbnResult, defaultNtdType) {
  const existingNtdId = resolveExistingNtdId(orderItem, sqNbnResult);
  const mods = orderItem.ntdModifications || "";
  const isTransfer = orderItem.orderType === "Transfer";
  const ntdType =
    orderItem.ntdType != null &&
    orderItem.ntdType !== "" &&
    orderItem.ntdType !== "Internal"
      ? orderItem.ntdType
      : defaultNtdType;

  const isReplace =
    mods === NTD_MODIFICATION_OPTIONS.REPLACE_SELECTED ||
    orderItem.replaceNtd === true ||
    orderItem.ntdId === "NTD Installation Required";

  const isRequestNew =
    !isReplace &&
    (mods === NTD_MODIFICATION_OPTIONS.REQUEST_NEW ||
      orderItem.ntdId === "Additional NTD Required" ||
      orderItem.ntdId === "Additional Line Installation");

  // Transfer must always reference the on-site NTD (SOG-8559 / RJ001202 / RJ001000).
  if (isTransfer || (!isReplace && !isRequestNew)) {
    if (existingNtdId) {
      resource.action = "NO CHANGE";
      resource.product.id = existingNtdId;
      return { action: "NO CHANGE", existingNtdId };
    }
  }

  if (isReplace) {
    resource.action = "ADD";
    resource.product.ntdType = ntdType;
    // NBN replace requires the NTD ID being replaced (RJ001000 when omitted).
    if (existingNtdId) {
      resource.product.id = existingNtdId;
    }
    return { action: "ADD", existingNtdId, isReplace: true };
  }

  // REQUEST NEW / greenfield — new NTD, no id
  resource.action = "ADD";
  resource.product.ntdType = ntdType;
  return { action: "ADD", existingNtdId, isReplace: false };
}

// Helper function to get NTD modification options based on NTD ID and conditions
export function getNtdModificationOptions(
  ntdId,
  currentNtd,
  hasUsedPort,
  checkBandwidthExceeded,
  featureFlags,
  orderType,
  isFibre,
  productType,
  bandwidthProfile,
  speedTiersSupported
) {
  const result = [];

  if (productType === "Fixed Wireless") {
    return [
      getForcedFixedWirelessNtdModification({
        ntdId,
        currentNtd,
        orderType,
        bandwidthProfile,
        speedTiersSupported
      })
    ];
  }

  // SOG-8559: Transfer orders can only use the existing NTD on-site.
  // NBN rejects NTD Action ADD on service transfers (RJ001202).
  if (orderType === "Transfer") {
    result.push(NTD_MODIFICATION_OPTIONS.USE_SELECTED);
    return result;
  }

  if(featureFlags.sog8562 && isFibre){
    if(featureFlags.sog8191) {
      const sqVersion = normalizeNtdVersion(currentNtd?.NTDVersion);

      const isAdditionalLine = ntdId === "Additional Line Installation";
      const isAdditionalNtd = ntdId === "Additional NTD Required";
      const isNtdInstallationRequired = ntdId === "NTD Installation Required";
      const isEmpty = !ntdId;

      // No valid NTD available.
      if (isAdditionalLine || isEmpty) {
        return [NTD_MODIFICATION_OPTIONS.REQUEST_NEW];
      }

      // V3 1-port: used port → REPLACE (order a 4_PORT); free port → use / optional new
      if (sqVersion === "V3" || isV3SinglePortNtd(currentNtd)) {
        if (isNtdInstallationRequired || ntdAllPortsUsed(currentNtd)) {
          return [NTD_MODIFICATION_OPTIONS.REPLACE_SELECTED];
        }

        return [
          NTD_MODIFICATION_OPTIONS.USE_SELECTED,
          NTD_MODIFICATION_OPTIONS.REQUEST_NEW
        ];
      }

      // V1 / V4 (multi-port) — same Connect rules
      if (sqVersion === "V1" || sqVersion === "V4" || isMultiPortNtd(currentNtd)) {
        if (isAdditionalNtd || ntdAllPortsUsed(currentNtd)) {
          return [NTD_MODIFICATION_OPTIONS.REQUEST_NEW];
        }

        if (sqVersion === "V1") {
          return [
            NTD_MODIFICATION_OPTIONS.USE_SELECTED,
            NTD_MODIFICATION_OPTIONS.REPLACE_SELECTED
          ];
        }

        // V4 (and other multi-port): use selected or request new
        return [
          NTD_MODIFICATION_OPTIONS.USE_SELECTED,
          NTD_MODIFICATION_OPTIONS.REQUEST_NEW
        ];
      }

      // Fallback
      return [NTD_MODIFICATION_OPTIONS.REQUEST_NEW];
    } else {
      const isNoValidNtd = ntdId === "Additional Line Installation" || !ntdId;

      // No valid NTD → REQUEST_NEW only
      if (isNoValidNtd) {
        return [NTD_MODIFICATION_OPTIONS.REQUEST_NEW];
      }
    
      const ntdType = currentNtd?.NTDType?.toLowerCase();
      const { original = [] } = checkBandwidthExceeded || {};
    
      const hasNtdFreePort =
        currentNtd?.uniPortD?.some(port => port.status === "Free") ?? false;
    
      const isLimitedType =
        ntdType === "internal" || ntdType === "1_port";
    
      // USE_SELECTED → can handle bandwidth
      if (original?.length) {
        result.push(NTD_MODIFICATION_OPTIONS.USE_SELECTED);
      }
    
      // REPLACE_SELECTED → (limited type + free port) OR orderType = "Connect"
      if ((isLimitedType && hasNtdFreePort) || orderType === "Connect") {
        result.push(NTD_MODIFICATION_OPTIONS.REPLACE_SELECTED);
      }
    
      // REQUEST_NEW → no free ports
      if (!hasNtdFreePort) {
        result.push(NTD_MODIFICATION_OPTIONS.REQUEST_NEW);
      }
    }
  } else {
    if (
      ntdId === "Additional Line Installation" ||
      ntdId === null ||
      ntdId === ""
    ) {
      result.push(NTD_MODIFICATION_OPTIONS.REQUEST_NEW);
      return result;
    }

    if (ntdId !== "" && ntdId !== null) {
      const ntdType = currentNtd?.NTDType;
      const { exceeded, original } = checkBandwidthExceeded;

      if (original.length > 0) {
        result.push(NTD_MODIFICATION_OPTIONS.USE_SELECTED);
      }
      if (exceeded.length > 0) {
        result.push(NTD_MODIFICATION_OPTIONS.REQUEST_NEW);
      }
      if (
        (ntdType?.toLowerCase() === "internal" ||
          ntdType?.toLowerCase() === "1_port") &&
        !hasUsedPort
      ) {
        result.push(NTD_MODIFICATION_OPTIONS.REPLACE_SELECTED);
      }
    }
  }

  return result;
}


// Helper function to get NTD type options based on conditions
export function getNtdTypeOptions(
  ntdId,
  ntdModifications,
  currentNtd,
  portsOnNtd,
  isOriginal,
  serviceClass,
  productType,
  featureFlags,
  isFibreConnect,
  sqNbnResult,
  orderType
) {
  const result = [];

  if (productType === "Fixed Wireless") {
    return [NTD_TYPE_FIXED_WIRELESS];
  }

  if(productType === "HFC") {
    if(isOriginal) return NTD_TYPE_OPTIONS_HFC;
    else {
      if (ntdId === "Additional Line Installation") return ["NTD_2.5"]
      else {
        if(featureFlags?.sog8713) {
          const resources = sqNbnResult.sq.siteRestriction.supportingResource;

          let hasFreePort = false;
          let typeValue = null;

          for (const x of resources) {
            if (x.uniPortD?.some(port => port.status === "Free")) {
              hasFreePort = true;
            }

            typeValue = x.ntdDetails?.find(item => item.name === "Type")?.value;

            if (hasFreePort) break;
          }

          if (
            ntdModifications === "REPLACE SELECTED NTD" ||
            ntdModifications === "REQUEST NEW NTD"
          ) {
            return ["NTD_2.5"];
          }

          const useSelectedNtdWithFreePort =
            ntdModifications === "USE SELECTED NTD" && hasFreePort;
                  
          const isTransferWithSog8883Enabled =
            featureFlags?.sog8883 && orderType?.toLowerCase() === "transfer";
                  
          if (useSelectedNtdWithFreePort || isTransferWithSog8883Enabled) {
            // For isTransferWithSog8883Enabled: transfer orders reuse the existing NTD's port assignment,
            // therefore the free-port requirement does not apply.
            return [typeValue];
          }
        } else return ["NTD_2.5"]
      }
    }
  } else {
    if (
      ntdId === "Additional Line Installation" &&
      (productType === "Fibre" || productType === "FTTP")
    ) {
      if (featureFlags.sog8562) {
        return isFibreConnect ? NTD_TYPE_OPTIONS : ["4_PORT"];
      } else {
        return NTD_TYPE_OPTIONS;
      }
    }

    if(featureFlags?.sog8191){
      // Connect + V3 (1_PORT) + Used UNI-D => NTD Installation Required + 4_PORT
      const isV3SinglePort =
        sqNbnResult?.sq?.siteRestriction?.supportingResource?.some(resource =>
          isV3SinglePortNtd(resource)
        );
      
      if (
        ntdId === "NTD Installation Required" &&
        orderType === "Connect" &&
        (productType === "Fibre" || productType === "FTTP") &&
        isV3SinglePort
      ) {
        return ["4_PORT"];
      }
    }

    if (
      ntdId !== "NTD Installation Required" &&
      ntdId != null &&
      ntdId !== "" &&
      ntdModifications !== ""
    ) {
      const ntdType = currentNtd?.NTDType;

      const isFibreType =
        productType === "Fibre" || productType === "FTTP";

      if (featureFlags.sog8562 && isFibreType) {
        if (ntdModifications === NTD_MODIFICATION_OPTIONS.USE_SELECTED) {
          result.push(ntdType);
          return result;
        }

        if (
          ntdModifications === NTD_MODIFICATION_OPTIONS.REPLACE_SELECTED ||
          ntdModifications === NTD_MODIFICATION_OPTIONS.REQUEST_NEW
        ) {
          return isFibreConnect ? NTD_TYPE_OPTIONS : ["4_PORT"];
        }
      } else {
        if (ntdModifications === NTD_MODIFICATION_OPTIONS.USE_SELECTED) {
          result.push(ntdType);
        } else if (
          ntdModifications ===
          NTD_MODIFICATION_OPTIONS.REPLACE_SELECTED
        ) {
          if (ntdType?.toLowerCase() === "internal") {
            if (portsOnNtd === 1) result.push("1_PORT");
            if (isFibreType) {
              result.push("4_PORT");
            }
          }

          if (ntdType?.toLowerCase() === "1_port") {
            if (isFibreType) {
              result.push("4_PORT");
            }
          }
        } else if (
          ntdModifications === NTD_MODIFICATION_OPTIONS.REQUEST_NEW
        ) {
          if (ntdType?.toLowerCase() === "internal") {
            if (isFibreType) {
              result.push("4_PORT");
            } else {
              result.push("1_PORT");
            }
          }

          if (ntdType?.toLowerCase() === "1_port") {
            if (isFibreType) {
              result.push("4_PORT");
            }
          }

          if (ntdType?.toLowerCase() === "4_port") {
            if (isFibreType) {
              result.push("4_PORT");
            }
          }
        }
      }

      return result;
    } else {
      if (
        isOriginal &&
        serviceClass === "3" &&
        ntdId != null &&
        ntdId !== ""
      ) {
        const ntdType = currentNtd?.NTDType;
        result.push(ntdType);
        return result;
      }

      if (!isOriginal) {
        if (productType === "Fibre" || productType === "FTTP") {
          return NTD_TYPE_OPTIONS;
        } else {
          return ["1_PORT"];
        }
      }
    }
  }

  return result;
}


